/**
 * 获取 URL 参数
 * @param {string} name 参数名
 * @returns {string|null} 参数值
 */
export function getUrlParam (name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURIComponent(r[2])
    return null
}

/**
 * 获取 URL 中的所有参数
 * @returns {Object} 参数对象
 */
export function getAllUrlParams () {
    const params = {}
    const search = window.location.search.substr(1)
    if (search) {
        search.split('&').forEach(item => {
            const [key, value] = item.split('=')
            params[decodeURIComponent(key)] = decodeURIComponent(value)
        })
    }
    return params
}



// WEBPACK FOOTER //
// ./src/utils/common.js